/**
 * Registry export utilities — 7-year filter options and CSV/Excel export for reporting
 */

// Last 7 years (calendar year) for regulatory retention
export function getYearOptions() {
  const currentYear = new Date().getFullYear()
  const years = []
  for (let i = 0; i < 7; i++) {
    years.push(currentYear - i)
  }
  return years
}

// Export table data to CSV (opens in Excel)
export function exportToCsv(rows, columns, filename) {
  const escape = (v) => {
    if (v == null || v === '') return ''
    const s = String(v)
    if (s.includes(',') || s.includes('"') || s.includes('\n')) {
      return `"${s.replace(/"/g, '""')}"`
    }
    return s
  }
  const header = columns.map((c) => escape(c.header)).join(',')
  const lines = rows.map((row) =>
    columns.map((c) => escape(c.accessor ? c.accessor(row) : row[c.key])).join(',')
  )
  const csv = [header, ...lines].join('\n')
  const blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename || `export-${new Date().toISOString().slice(0, 10)}.csv`
  a.click()
  URL.revokeObjectURL(url)
}
